let lastTimestamp = 0;
let lastWindowScroll = -1;

const doParallax = (timestamp) => {
	if (timestamp > lastTimestamp + 32) {
		if (lastWindowScroll !== window.scrollY) {
			document.body.style.setProperty(
				'--occ-parallax-window-scroll',
				`${window.scrollY}px`
			);
			lastWindowScroll = window.scrollY;
		}

		lastTimestamp = timestamp;
	}

	window.requestAnimationFrame(doParallax);
};

const updateScrollPosition = (element) => {
	element.style.setProperty(
		'--occ-parallax-scroll-position',
		`${element.offsetTop}px`
	);
};

const resizeObserver = new ResizeObserver((entries) => {
	for (const entry of entries) {
		updateScrollPosition(entry.target);
	}
});

document.querySelectorAll('.occ-parallax-container').forEach((element) => {
	resizeObserver.observe(element);
});

doParallax();
